const SDK_VERSION = "10.74.0" ;

export { SDK_VERSION };
//# sourceMappingURL=version.js.map
